/**
 * AGRO-INVEST API Configuration
 * - localhost:3000 → http://localhost:5000 (avoids SSL issues)
 * - agroinvezt.tech → https://api.agroinvezt.tech
 */

const isLocalhost = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (isLocalhost ? 'http://localhost:5000' : 'https://api.agroinvezt.tech');

export const getApiUrl = (path) => {
  const base = API_BASE_URL.replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
};
